<template>
	<div>
		<div :class="isChain?'chain_RelatedReport':''">
			<h2 class="chain_title1" v-if="isChain">全国{{ title }}投资项目</h2>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="25vh">
				<freeUserTips :type="4" :bgtype="0" :isShowDownFile="true"></freeUserTips>
			</el-dialog>
			<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
				<tr>
					<th>排名</th>
					<th>公司名称</th>
					<th>项目名称</th>
					<th>投资来源地</th>
					<th>行业</th>
					<!-- <th>概念</th> -->
					<th>投资地点</th>
					<th>投资金额</th>
					<th>日期</th>
				</tr>
				<tr :key="i" v-for="(list, i) in investList">
					<td>{{ i + 1 }}</td>
					<td>
						<span class="fwb curp" v-if="list.stockCode != ''"
							@click="routerlinkid('/enterprises', list.stockCode)">{{ list.shortName }}</span>
						<span v-if="list.stockCode == ''">{{ list.shortName }}</span>

					</td>
					<td style="width:200px;"><span :class="(list.url && list.url != '') ? 'curp' : ''"
							@click="openProjectLink(list.url)">{{ list.projectName }}</span></td>
					<td>{{ list.sourceArea }}</td>
					<td>{{ list.industry }}</td>
					<!-- <td>{{list.notion}}</td> -->
					<td>{{ list.investArea }}</td>
					<td>{{ list.money }}{{ list.moneyUnit }}</td>
					<td>{{ list.time }}</td>
				</tr>
			</table>
			<p  v-if="isChain" class="text-center my-2 curp widthPC-100 font-18" @click="openUrl('invest')">更多投资项目 ></p>
		</div>
	</div>
</template>
<script>
import { sortKey } from '@/utils/index'
export default {
	data() {
		return {
			userdata: {},
			isShowFreeUserTips:false
		}
	},
	props: {
		userdata: {},
		investList: { type: Array, default: [] },
		title: { type: String, default: '' },
		isChain:{type:Boolean,default:true},//产业链详情和竞争格局、市场规模都用到了这个组件
	},
	mounted() {
		this.userdata = this.getuseriformation();
		sortKey(this.investList,'time',1);
	},
	methods: {
		openProjectLink(url) {
			if (url && url != '') {
				window.open(url); //研究报告库外部跳转
			}
		},

		openUrl(url) { //外部跳转拿地信息库 投资项目库跳转
			if(!this.userdata.token){
				this.isShowFreeUserTips = true;
				return;
			}
			if (url == "land" || url == 'invest') {
				this.$axios.get(this.$api.enterpriseapi.land.url(), {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function (res) {
					window.open(res.data.data[url]);
					// that.listUrl=res.data.data.invest; 
				})
			}
		}

	}
}
</script>
